export default __webpack_public_path__ + "5142b9de7dff0732a6f4cac669664de4.png";